<template lang="pug">
#collect-group-wc
  .header
    .group-icon
      span.group-layers-icon
    .group-text
      h4 {{ title }}
  .body
    .item-group(v-for='group in groups', :key='group.nome')
      group-layer(
        :group='group',
        :show-layers='true',
        @layer:toggle='toggleLayers'
      )
</template>

<script>
  import GroupLayer from './GroupLayer.vue'

  export default {
    name: 'CollectionGroup',
    components: {
      GroupLayer,
    },
    props: {
      groups: Array,
    },
    data() {
      return {
        title: 'Camadas',
      }
    },
    methods: {
      toggleLayers(event) {
        this.$emit('layer-toggle', event)
      },
    },
  }
</script>

<style scoped lang="scss">
  #collect-group-wc {
    display: grid;
    position: relative;
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    .item-group {
      width: 100%;
    }

    .header {
      background-color: #f5f5f5;
      box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.16);
      width: 100%;
      height: 57px;
      display: flex;
      font-family: 'Roboto', sans-serif;
      text-align: left;
      margin-bottom: 3px;
      color: #333333;
      opacity: 1;

      h4 {
        font-weight: 600;
      }

      .group-text {
        width: 80%;
        height: 100%;
      }

      .group-icon {
        width: 20%;
        height: 100%;
        margin-right: 3%;
      }
    }

    .body {
      overflow-y: auto;
    }

    .group-layers-icon {
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTExLjk5IDE4LjU0bC03LjM3LTUuNzNMMyAxNC4wN2w5IDcgOS03LTEuNjMtMS4yNy03LjM4IDUuNzR6TTEyIDE2bDcuMzYtNS43M0wyMSA5bC05LTctOSA3IDEuNjMgMS4yN0wxMiAxNnoiLz48L3N2Zz4=);
      background-repeat: no-repeat;
      background-position: center;
      width: 100%;
      height: 100%;
      display: block;
    }
  }
</style>
